import { useState, createContext } from "react";

import { languageOptions, dictionaryList } from "../languages";
import clearStore from "../utils/IndexedDB/clearStore";

// create the language context with default selected language
export const LanguageContext = createContext({
  userLanguage: "pe",
  dictionary: dictionaryList.pe,
});

// it provides the language context to app
export function LanguageProvider({ children }) {
  const defaultLanguage = window.localStorage.getItem("rcml-lang");
  const [userLanguage, setUserLanguage] = useState(defaultLanguage || "pe");

  const provider = {
    userLanguage,
    dictionary: dictionaryList[userLanguage],
    userLanguageChange: (selected) => {
      const newLanguage = languageOptions[selected] ? selected : "pe";
      setUserLanguage(newLanguage);
      window.localStorage.setItem("rcml-lang", newLanguage);
      clearStore("Enums");
    },
  };

  return <LanguageContext.Provider value={provider}>{children}</LanguageContext.Provider>;
}
